import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronRight } from "lucide-react";

const INSTRUCTIONS = {
    okta: "ssoSettings.instructionsOkta",
    azure_ad: "ssoSettings.instructionsAzure",
    generic_oidc: "ssoSettings.instructionsGeneric",
};

const STEPS = {
    okta: ["ssoSettings.oktaStep1", "ssoSettings.oktaStep2", "ssoSettings.oktaStep3", "ssoSettings.oktaStep4"],
    azure_ad: ["ssoSettings.azureStep1", "ssoSettings.azureStep2", "ssoSettings.azureStep3", "ssoSettings.azureStep4"],
    generic_oidc: ["ssoSettings.genericStep1", "ssoSettings.genericStep2", "ssoSettings.genericStep3"],
};

export default function SSOProviderInstructions({ providerType, redirectUrl }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const steps = STEPS[providerType] || STEPS.generic_oidc;
    const title = INSTRUCTIONS[providerType] || INSTRUCTIONS.generic_oidc;

    return (
        <div className="border border-blue-200 rounded-lg">
            <button type="button" onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between p-3 text-sm font-medium text-blue-700 hover:bg-blue-50 rounded-lg">
                <span>{t(title)}</span>
                {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
            </button>
            {open && (
                <div className="px-3 pb-3">
                    <ol className="list-decimal pl-5 space-y-2 text-xs text-gray-700">
                        {steps.map((stepKey) => (
                            <li key={stepKey}>{t(stepKey, { redirectUrl })}</li>
                        ))}
                    </ol>
                </div>
            )}
        </div>
    );
}
